module.exports = __webpack_public_path__ + "static/media/avatar_snail.697a3d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_snail.png
// module id = 397
// module chunks = 0